import * as React from 'react';

import { cn } from '@/components/atoms/primitives/utils';

/**
 * WEB-1001 — the design-system status pill (DS 1.9.0 `.a-status`): mono caps
 * flagging a row's state. Semantic variants only — there is no neutral
 * default, because status is meaningful, never decorative.
 */
export type StatusVariant = 'onsale' | 'sold' | 'draft' | 'past' | 'live' | 'warning' | 'danger';

export interface StatusProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant: StatusVariant;
  /** Drops the leading dot. */
  bare?: boolean;
}

export function Status({
  variant,
  bare = false,
  className,
  ...props
}: StatusProps): React.ReactElement {
  return (
    <span
      className={cn('a-status', `a-status--${variant}`, bare && 'a-status--bare', className)}
      {...props}
    />
  );
}
